$(document).ready(function () {

    $("#btnMobileMenu").click(function () {
        $("#divMobileMenu").show();
        $(this).hide();
        $("#btnMobileClose").show();
        $(".search-button").hide();
        $("body").addClass("menu-open");
    });

    $("#btnMobileClose").click(function () {
        $("#divMobileMenu").hide();
        $(this).hide();
        $("#btnMobileMenu").show();
        $(".search-button").show();
        $(".sub-menu").hide();
        $("body").removeClass("menu-open");
    });

    $("a[data-submenu-target]").click(function () {
        var targetId = $(this).attr("data-submenu-target");
        var target = $("#" + targetId);
        if (target.css("display") == "none") {
            target.slideDown();
            $(".mobile-back").show();
        } else {
            target.slideUp();
            $(".mobile-back").hide();
        }
    });

    $(".mobile-back").click(function () {
        $(".mobile-back").hide();
        $(".sub-menu").hide();       
    });

    $(".dd-menu-controller").click(function (e) {
        var href = $(this).attr("href");
        if (href == "#") {
            e.preventDefault();
            var closing = $(this).hasClass("shown");
            ddHideAll();

            if (!closing) {
                var menuId = $(this).attr("data-menu-id");
                var menu = $(menuId);
                $(this).addClass("shown");
                menu.show();
            }
        }
    });

    $(document).click(function (e) {
        var t = e.target;
        if (!$(t).is(".dd-menu-controller") && !$(t).parents().is(".dd-menu-controller")
            && !$(t).parents().is(".dd-wrapper")) {
            ddHideAll();
        }
    });

    function ddHideAll() {
        $(".dd-item").hide();
        $(".dd-menu-controller").removeClass("shown");
    }

});